module.exports = __webpack_public_path__ + "img/wxewm.9fcc0a7c.jpg";